module.exports = __webpack_public_path__ + "static/img/9.b3ee7b27.png";